import { Button, Divider, Text, VStack } from '@chakra-ui/react';
import { useUITranslation } from '../../context/TranslationProvider';

type LoadMoreProps = {
  loadedItems: number;
  totalItems: number;
  loadMoreAmount: number;
  isLoading?: boolean;
  testId?: string;
  onShowMore?: () => void;
};

export const LoadMore = ({
  loadedItems,
  totalItems,
  loadMoreAmount,
  isLoading,
  testId = 'load-more',
  onShowMore,
}: LoadMoreProps) => {
  const { t } = useUITranslation();

  const amount =
    totalItems - loadedItems > loadMoreAmount ? loadMoreAmount : totalItems - loadedItems;
  const hasMore = loadedItems < totalItems;

  return (
    <VStack spacing="space.16" mt="space.24" data-testid={`${testId}-container`}>
      <Divider m="0" />
      <Text color="gray.4" fontSize="sm" data-testid={`${testId}-text`}>
        {t('search.load-more.description', { results: loadedItems, total: totalItems })}{' '}
      </Text>
      {hasMore && (
        <Button
          isLoading={isLoading}
          data-testid={`${testId}-button`}
          type="button"
          size="lg"
          fontWeight="medium"
          onClick={onShowMore}
          variant="secondary"
          borderRadius={50}
        >
          {t('search.load-more.button.label', { amount })}
        </Button>
      )}
    </VStack>
  );
};
